import actionCreatorFactory from "typescript-fsa";

import {Ganymede} from "@slices/Ganymede/UserManager";
import {Permissions} from "@slices/Permissions/Permissions";

import {routeActions} from "src/utils/router";


const actionCreator = actionCreatorFactory('routes/users');

export const usersRoute = routeActions(actionCreator);

export const searchProviderChanged =
  actionCreator<string>('SEARCH_PROVIDER_CHANGED');

export const searchTextChanged =
  actionCreator<string>('SEARCH_TEXT_CHANGED');

export const searchFormSubmitted = actionCreator('SEARCH_FORM_SUBMITTED');

export const userClicked = actionCreator<{row: number}>('USER_CLICKED');

export const getUsers = actionCreator.async<{
  provider: string;
  search: string;
}, Ganymede.User[]>('GET_USERS');

export const getUserPermissions = actionCreator.async<
  Ganymede.User,
  Permissions.AbstractPermission[]
>('GET_USER_PERMISSIONS');

export const userDialogClosed = actionCreator('USER_DIALOG_CLOSED');

export const permissionToggled = actionCreator<{
  typeId: string;
  granted: boolean;
}>('PERMISSION_TOGGLED');

export const togglePermission = actionCreator.async<{
  typeId: string;
  granted: boolean;
}, Permissions.AbstractPermission[]>('TOGGLE_PERMISSION');



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/routes/users/Users.actions.ts